export const bookingNoteDefaultPrivacyOptions = [
  {
    text: 'Public',
    value: 'public',
  },
  {
    text: 'Internal',
    value: 'internal',
  },
  {
    text: 'Only Me',
    value: 'private',
  },
];



// WEBPACK FOOTER //
// ./src/constants/bookingNote.js